// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f77ab7e2","453":"42e6a660"}[chunkId] + ".chunk.js";
};